import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { useThemeStore } from "@/stores/theme.store.js";
import { getAwsEnvironmentConfig, getStorageBucketRegistry } from "@/config/awsEnvironment.js";
import { PrefixedKeyValueStorage } from "@/utils/prefixedKeyValueStorage.js";
import { purgeForeignEnvironmentArtifacts } from "@/utils/authStorage.js";

import "@/styles/index.css";

loadFonts();

const awsConfig = getAwsEnvironmentConfig();

purgeForeignEnvironmentArtifacts(awsConfig);

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new PrefixedKeyValueStorage(`yandle-amplify:${awsConfig.environment}`),
);

Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: awsConfig.userPoolId,
        userPoolClientId: awsConfig.userPoolClientId,
        identityPoolId: awsConfig.identityPoolId,
        allowGuestAccess: true,
        region: awsConfig.region,
        loginWith: { email: true },
      },
    },
    API: {
      GraphQL: {
        endpoint: awsConfig.graphqlEndpoint,
        region: awsConfig.region,
        defaultAuthMode: "userPool",
        apiKey: awsConfig.graphqlApiKey,
      },
    },
    Storage: {
      S3: {
        bucket: awsConfig.bucket,
        region: awsConfig.bucketRegion,
        buckets: getStorageBucketRegistry(awsConfig),
      },
    },
  },
  {
    Storage: {
      S3: {
        defaultAccessLevel: "guest",
      },
    },
  },
);

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(vuetify);

const themeStore = useThemeStore();
themeStore.init();

app.mount("#app");
